import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import React from 'react';
import { Payout } from '../../models';

interface PayoutsAgGridTableProps {
    payouts: Payout[];
    columnDefs: ColDef[];
    isLoading?: boolean;
    isFetching?: boolean;
    sorting?: { field: string; direction: 'asc' | 'desc' } | null;
    onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
    onPageChange?: (page: number) => void;
    currentPage?: number;
    totalPages?: number;
}

export const PayoutsAgGridTable = React.memo(
    function PayoutsAgGridTable({
        payouts,
        columnDefs,
        isLoading = false,
        isFetching = false,
        sorting,
        onSortingChange,
    }: PayoutsAgGridTableProps) {
        return (
            <div
                className={
                    isFetching
                        ? 'opacity-50 pointer-events-none transition-opacity duration-200'
                        : ''
                }
            >
                <AgGridTable
                    data={payouts}
                    columnDefs={columnDefs}
                    height="calc(100vh - 200px)"
                    enableSelection={false}
                    isLoading={isLoading}
                    rowHeight={56}
                    sorting={sorting}
                    onSortingChange={onSortingChange}
                />
            </div>
        );
    }
);
